import { Box } from '@mui/material'
import React from 'react'

interface TabButtonProps {
  label: string
  icon: React.ReactNode
  isSelected: boolean
  onClick: () => void
  className?: string
}

export const TabButton = ({
  label,
  icon,
  isSelected,
  className,
  onClick }: TabButtonProps) => {
  return (
    <Box
      onClick={onClick}
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: '20px',
        fontSize: '15px',
        fontWeight: 500,
        padding: '8px 20px',
        fontStyle: 'normal',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        color: isSelected ? '#ffffff' : '#666666',
        backgroundColor: isSelected ? '#3551F2' : 'transparent',
        border: isSelected ? '1px solid #1976d2' : '1px solid transparent',
        '&:hover': {
          backgroundColor: isSelected ? '#1976d2' : 'rgba(0, 0, 0, 0.04)'
        }
      }}
    >
      <Box sx={{ marginRight: '8px', display: 'flex', alignItems: 'center', fontSize: '18px' }}>{icon}</Box>
      {label}
    </Box>
  )
}
